angular.module("avlib").directive("avTable", function(){
	return {
		restrict: "E",
		transclude: true,
		scope: {
			data:'=',
			selectionModel:"=?",
			tableModel:'=?',
			sortModel: '=?',
			paginationModel:'=?',
			dropdownActions:"=?",
			tableConfig:"=?",
		},
		
		template: require('!html-loader!./TableTemplate.html'),
		
		controller: ["$scope", "$timeout", function($scope, $timeout){
		
			var modelToViewColMap = [];
			var viewToModelColMap = [];
		
			var ignoreSelectAllChanged = false;
			
			var initModelViewColMap = function(){
				var viewIndex = -1;
				var i;
				for (i=0; i<=$scope.tableModel.getColumnCount()-1; i++){
					if ($scope.tableModel.isColumnVisible(i)){
						viewIndex++;
						viewToModelColMap[viewIndex] = i;
						modelToViewColMap[i] = viewIndex;
					}else{
						modelToViewColMap[i] = -1;
					}
				}
			};
	
			$scope.filteredData = [];
			/*
			 * O usuário tem a opção de fornecer na inicialização um modelo de ordenação com configurações
			 * personalizadas. Caso o modelo não tenha sido fornecido, inicializaremos a tabela com um
			 * modelo contendo configurações default.
			 */	
			if ($scope.sortModel == null){
				$scope.sortModel = {
					// Coluna que está ativa para ordenação
					sortColumn: 1,
					// Indica ordenação ascedente (false) ou descendente (true)
					sortOrder: false,
				};
			}
			/**
			 * Modelo de dados para controlar a paginação dos itens da tabela.
			 */
			if ($scope.paginationModel == null){
				$scope.paginationModel = {
					currentPage: 0,
					pageSize: 100,
					pageCount: 0,
					itemCount: 0,
				};
			}

			if ($scope.selectionModel == null){
				$scope.selectionModel = {
					selectedData: [],
					// Indica quando a checkbox de seleção de todos os itens encontra-se selecionada na interface
					checkboxAllSelected: false,
					// Quantidade total de itens selecionados no momento
					selectionCount: 0,

					selectAllChanged: function(selectAll){
					},

					clearSelection: function(){
						this.checkboxAllSelected = false;
						this.selectionCount = 0;
						if ($scope.data){
							$scope.data.forEach(function (item){
								item.selected = false; 
							});
						}
					},
						
					updateSelectionCount: function(){
						$scope.selectionModel.selectionCount = 0;
						$scope.data.forEach(function (item){
							if (item.selected) $scope.selectionModel.selectionCount++; 
						});			
					}
				};	
			}

			$scope.tableCallback = {
				itemRemoved: function(item){
					var viewIndex = $scope.filteredData.findIndex(function (otherItem){
						return item == otherItem;
					});
					$scope.filteredData.splice(viewIndex, 1);
					if (item.selected){
						$scope.selectionModel.selectionCount--;
					}					
				}
			};
	
			$scope.modelToViewColIndex = function(modelIndex){
				return modelToViewColMap[modelIndex];
			};
				  
			$scope.viewToModelColIndex = function(viewIndex){
				return viewToModelColMap[viewIndex];
			};
	
			/**
			 * Listener para o click em algum dos títulos das colunas das tabelas. O clique nos
			 * títulos das colunas dispara a ordenação dos resultados de acordo com o conteúdo
			 * da coluna selecionada.
			 */
			$scope.sortKeyChanged = function(columnIndex){
				/*
				 * Se a coluna selecionada é idêntica a coluna já selecionada, entendemos que
				 * o objetivo é reverter a ordem empregada (descendente ou ascendente).
				 */
				if (columnIndex == $scope.sortModel.sortColumn){
					$scope.sortModel.sortOrder = !$scope.sortModel.sortOrder;
				}
				/*
				 * Com base na coluna selecionada pelo usuário, ajustando o chave de ordenação
				 * que será empregada:
				 */
				$scope.sortModel.sortColumn = columnIndex;
				/*
				 * Ativando o ícone de ordenação apenas na coluna selecionada pelo usuário:
				 */
				var tableId = $scope.tableModel.getTableId();
				$('#'+tableId+' th i').removeClass('fa-sort-asc');
				$('#'+tableId+' th i').removeClass('fa-sort-desc');
				/*
				 * Escolhendo o ícone para identificar a ordenação ascendente ou descendente.
				 */
				var viewIndex = $scope.modelToViewColIndex(columnIndex);
				var iElement = $('#'+tableId+' th i').slice(viewIndex, viewIndex+1);
				iElement.addClass('fa-sort-'+($scope.sortModel.sortOrder ? "desc" : "asc"));
			};

			/*
			 * Devolve para o template a chave de ordenação que deverá ser utilizada para ordenar
			 * o item da tabela especificado como argumento. O método, por sua vez, delega essa
			 * responsabilidade para o table model, complementando com a informação de qual a
			 * coluna que encontra-se ativa para a ordenação.
			 */
			$scope.getSortKey = function(item){
				return $scope.tableModel.getSortKey(item, $scope.sortModel.sortColumn);
			};

			/**
			 * Listener para o checkbox responsável por selecionar ou deselecionar, de uma
			 * só vez, todos os itens filtrados da listagem.
			 */
			$scope.selectAllCheckboxChanged = function(){
				if (ignoreSelectAllChanged) return;
				var allSelected = $scope.selectionModel.checkboxAllSelected;
				// Marcando ou desmarcando todos os itens filtrados
				var changes = 0;
				$scope.data.forEach(function(item){
					if (item.selected != allSelected){
						changes++;
						item.selected = allSelected;
					}
				});
				/*
				 * Atualizando a contagem de itens selecionados. Nota sobre o uso de $timeout:
				 * No loop, ao atualizar o campo "selected", o listener "selecCheckboxChanged"
				 * é automaticamente acionado. Durante sua execução, atualiza o contador
				 * selectionModel.selectionCout. Para que este processo não interfira na quantidade
				 * final registrada de itens selecionados, o $timeout garante que estes listeners
				 * tenha finalizado sua execução antes de alterarmos o valor de selectionCount.
				 */
				$timeout(function(){
					$scope.selectionModel.selectAllChanged(allSelected);
				}, 0);
			};

			/**
			 * Listener para os checkboxes responsáveis por selecionar ou deselecionar um
			 * item específico da listagem.
			 */
			$scope.selectCheckboxChanged = function(item){
				if (item.selected){
					$scope.selectionModel.selectionCount += 1;
				}else{
					$scope.selectionModel.selectionCount -= 1;
				}
			};					

			$scope.$watch("data.length", function(){
				if ($scope.data){
					$scope.paginationModel.itemCount = $scope.data.length;
					ignoreSelectAllChanged = true;
					$scope.selectionModel.checkboxAllSelected = false;
					$timeout(function(){ignoreSelectAllChanged = false;},0);
				}
			});
	
			$scope.isCheckboxColumnVisible = function(){
				if ($scope.tableConfig){
					if ($scope.tableConfig.checkboxColumnVisible !== undefined){
						return $scope.tableConfig.checkboxColumnVisible;
					}
				}
				return true;
			};

			initModelViewColMap();
		}] //controller,
	};
});